var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8159 5.17129L23.5517 6.71337C23.7923 7.21746 24.2715 7.56564 24.8252 7.63864L26.5192 7.86194C26.8111 7.90041 26.928 8.2601 26.7145 8.46278L25.4752 9.63913C25.0702 10.0237 24.8871 10.587 24.9888 11.1362L25.2999 12.8163C25.3535 13.1058 25.0475 13.3281 24.7888 13.1877L23.2871 12.3726C22.7962 12.1062 22.2038 12.1062 21.7129 12.3726L20.2112 13.1877C19.9525 13.3281 19.6465 13.1058 19.7001 12.8163L20.0112 11.1362C20.1129 10.587 19.9298 10.0237 19.5248 9.63913L18.2855 8.46278C18.072 8.2601 18.1889 7.90041 18.4808 7.86194L20.1748 7.63864C20.7285 7.56564 21.2077 7.21746 21.4483 6.71337L22.1841 5.17129C22.3109 4.9056 22.6891 4.9056 22.8159 5.17129Z",
    stroke: "#292D32",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 3.35,
    stroke: "#292D32",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7494 23.0344C19.36 22.0587 18.7822 21.1692 18.0491 20.4167C17.3159 19.6643 16.4417 19.0636 15.4764 18.649C14.5111 18.2344 13.4736 18.0139 12.4231 18.0003C11.3726 17.9867 10.3298 18.18 9.35401 18.5694C8.37826 18.9588 7.48877 19.5366 6.73632 20.2698C5.98386 21.0029 5.38318 21.8771 4.96857 22.8424",
    stroke: "#292D32",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 14.5C23.5 20.5751 18.5751 25.5 12.5 25.5C6.42487 25.5 1.5 20.5751 1.5 14.5C1.5 8.42487 6.42487 3.5 12.5 3.5C15.8164 3.5 18.79 4.9676 20.8067 7.28877L21.3236 7.12431C19.214 4.60336 16.0443 3 12.5 3C6.14873 3 1 8.14873 1 14.5C1 20.8513 6.14873 26 12.5 26C18.8513 26 24 20.8513 24 14.5C24 13.9805 23.9656 13.4691 23.8988 12.9678L23.3693 12.7993C23.4554 13.3536 23.5 13.9216 23.5 14.5Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.bf70dbd86b67b22989d56f3d32ce8adb.svg";
export { ForwardRef as ReactComponent };